import { Helpers } from '../../helpers';
import { IProjectStatus } from '../../interfaces/iproject-status';
import { Project } from '../project';
import { ProjectStatusMatrix } from '../project-status-matrix';
import { ProjectSuperStatus } from '../project-super-status';

export class ProjectStatusBase {
  ProjectStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ProjectSuperStatusId: number | null;

  Projects_ProjectStatus?: Array<Project> | null;
  ProjectStatusMatrix_CurrentProjectStatus?: Array<ProjectStatusMatrix> | null;
  ProjectStatusMatrix_NewProjectStatus?: Array<ProjectStatusMatrix> | null;
  ProjectSuperStatus?: ProjectSuperStatus;

  constructor(item?: IProjectStatus) {
    if (item) {

      this.ProjectStatusId = item.ProjectStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ProjectSuperStatusId = item.ProjectSuperStatusId;

      this.Projects_ProjectStatus = Helpers.createClassArray(Project, item.Projects_ProjectStatus);
      this.ProjectStatusMatrix_CurrentProjectStatus = Helpers.createClassArray(ProjectStatusMatrix, item.ProjectStatusMatrix_CurrentProjectStatus);
      this.ProjectStatusMatrix_NewProjectStatus = Helpers.createClassArray(ProjectStatusMatrix, item.ProjectStatusMatrix_NewProjectStatus);
      this.ProjectSuperStatus = new ProjectSuperStatus(item.ProjectSuperStatus);
    }
  }
}